import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { SafeHtml, DomSanitizer } from '@angular/platform-browser';

const LABEL_UOM_CHECK = ' (';

@Pipe({
  name: 'labelParser',
  standalone: false,
})
export class LabelParserPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string): SafeHtml {
    let result: string[] = value.includes(LABEL_UOM_CHECK) ? value.split(LABEL_UOM_CHECK) : [value];

    // Security: sanitize each segment to prevent XSS before embedding in HTML.
    // Use sanitize() instead of bypassSecurityTrustHtml() so Angular's built-in
    // sanitizer strips any dangerous content from the label segments.
    const sanitizeSegment = (segment: string) => this.sanitizer.sanitize(1 /* SecurityContext.HTML */, segment) ?? '';

    const htmlResult =
      Array.isArray(result) && result.length > 1
        ? `<span class="value">${sanitizeSegment(result[0])}</span> <span class="uom">(${sanitizeSegment(result[1])}</span>`
        : `<span>${sanitizeSegment(result[0])}</span>`;
    return this.sanitizer.sanitize(SecurityContext.HTML, htmlResult) ?? '';
  }
}
